import capitalize from 'lodash/capitalize';
import startCase from 'lodash/startCase';

import {
  StatusChipV2,
  StatusChipV2Color,
  StatusChipV2Props,
  Tooltip,
} from '@cast/design-system';
import {
  NodeMigrationStatusMigrationStatusEnum,
  WorkloadMigrationStatusMigrationStatusEnum,
} from '@cast/types';

import { RebalanceNodeEnum } from 'types/rebalance';

type MigrationStatus =
  | NodeMigrationStatusMigrationStatusEnum
  | WorkloadMigrationStatusMigrationStatusEnum
  | RebalanceNodeEnum
  | 'not-ready';

type Props = Omit<StatusChipV2Props, 'label' | 'color'> & {
  status: MigrationStatus;
  tooltip?: string;
};

const READY_STATUSES: MigrationStatus[] = [
  NodeMigrationStatusMigrationStatusEnum.ready,
  WorkloadMigrationStatusMigrationStatusEnum.ready,
  RebalanceNodeEnum.READY,
];

const NOT_READY_STATUSES: MigrationStatus[] = [
  NodeMigrationStatusMigrationStatusEnum.not_ready,
  WorkloadMigrationStatusMigrationStatusEnum.not_ready,
  RebalanceNodeEnum.NOT_READY,
  'not-ready',
];

const statusToColor = (status: MigrationStatus): StatusChipV2Color => {
  if (READY_STATUSES.includes(status)) {
    return 'success';
  }
  if (NOT_READY_STATUSES.includes(status)) {
    return 'error';
  }
  return 'neutral';
};

export const RebalanceMigrationStatusChip = ({
  status,
  tooltip,
  size = 'small',
  variant = 'subtle',
  className,
  ...props
}: Props) => {
  return (
    <Tooltip
      title={tooltip}
      placement="top"
      wrapIf={!!tooltip}
      testId="rebalance-status-tooltip"
    >
      <StatusChipV2
        label={capitalize(startCase(status as string))}
        color={statusToColor(status)}
        size={size}
        variant={variant}
        className={['RebalanceMigrationStatusChip-root', className]
          .filter(Boolean)
          .join(' ')}
        {...props}
      />
    </Tooltip>
  );
};
